import { useTranslation } from "next-i18next";
import Image from "@/components/Atoms/Image";
import styles from "./index.module.scss";
import { MultiPurposeTitle } from "@/components/Atoms/Title";
import { MultiPurposeParagraph } from "@/components/Atoms/Paragraph";
import { Disclosure, Transition } from "@headlessui/react";

import { Chevron } from "@/components/Atoms/Vectors";
interface Props {
  content: any;
  color: any;
  blockBgColor: any;
  conf: boolean;
  year: number;
}
export function RatingCard({
  content,
  color,
  blockBgColor,
  conf,
  year,
}: Props) {
  const { t } = useTranslation();
  const style = {
    "--r": blockBgColor?.color.red,
    "--g": blockBgColor?.color.green,
    "--b": blockBgColor?.color.blue,
  } as React.CSSProperties;

  return (
    <>
      <article
        style={style}
        className={`${styles.blockContainer} flex flex-col p-8`}
      >
        <div className="flex   flex-row items-center gap-6">
          <Image
            className="m-auto max-w-[5rem] lg:max-w-[7rem]"
            data={content.rating?.ratingImage}
          />
          <div className="flex flex-col min-w-[50%] flex-1">
            <MultiPurposeParagraph
              type="default"
              data={t("review")}
              color={color}
            />
            <MultiPurposeTitle
              tag="p"
              type="headline"
              color={color}
              data={content.mediaPublication?.title}
            />
          </div>
          {conf && (
            <Image
              className=" lg:flex m-auto  max-w-[4rem] lg:max-w-[6rem]"
              data={content.mediaPublication?.image}
            />
          )}
        </div>
        <Disclosure as="div" className="mt-2">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex gap-4 items-center ">
                {!open ? (
                  <MultiPurposeParagraph
                    type="default"
                    color={color}
                    data={t("showDetail")}
                  />
                ) : (
                  <MultiPurposeParagraph
                    type="default"
                    color={color}
                    data={t("hideDetail")}
                  />
                )}
                <span
                  className={`${
                    open ? "rotate-[-90deg] transform" : "rotate-90"
                  } `}
                >
                  <Chevron color={color} />
                </span>
              </Disclosure.Button>
              <Transition
                enter="transition duration-100 ease-out"
                enterFrom="transform opacity-0 -translate-y-2"
                enterTo="transform opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform  opacity-100"
                leaveTo="transform -translate-y-2 opacity-0"
              >
                <Disclosure.Panel className="pt-4 pb-2 flex flex-col">
                  <div className="mb-4 flex fle-row gap-12">
                    {content.taster?.length > 0 && (
                      <div className="flex flex-col gap-2">
                        {" "}
                        <MultiPurposeParagraph
                          type="default"
                          data={t("taster")}
                          color={color}
                        />
                        <div className="flex flex-col gap-1">
                          {content.taster.map((x: any, index: number) => (
                            <MultiPurposeParagraph
                              type="default"
                              key={index}
                              data={x?.title}
                              color={color}
                            />
                          ))}
                        </div>
                      </div>
                    )}

                    <div className="flex flex-col gap-2">
                      <MultiPurposeParagraph
                        type="default"
                        data={t("country")}
                        color={color}
                        weight={"bold"}
                      />
                      <MultiPurposeParagraph
                        type="image"
                        data={content.country?.title}
                        color={color}
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <MultiPurposeParagraph
                        type="default"
                        data={t("year")}
                        weight={"bold"}
                        color={color}
                      />
                      <MultiPurposeParagraph
                        type="image"
                        data={`${year}`}
                        color={color}
                      />
                    </div>
                  </div>
                  {content.tastingNote.length > 0 && (
                    <div className="flex flex-col gap-2">
                      <MultiPurposeParagraph
                        type="default"
                        weight={"bold"}
                        data={t("review")}
                        color={color}
                      />
                      <MultiPurposeParagraph
                        type="image"
                        data={content.tastingNote}
                        color={color}
                      />
                    </div>
                  )}
                </Disclosure.Panel>
              </Transition>
            </>
          )}
        </Disclosure>
      </article>
    </>
  );
}

export function AwardCard({ content, color, blockBgColor, conf, year }: Props) {
  const { t } = useTranslation();
  const style = {
    "--r": blockBgColor?.color.red,
    "--g": blockBgColor?.color.green,
    "--b": blockBgColor?.color.blue,
  } as React.CSSProperties;

  return (
    <>
      <article
        style={style}
        className={`${styles.blockContainer} flex flex-col p-8`}
      >
        <div className="flex flex-row items-center gap-6">
          <Image
            className="m-auto max-w-[5rem] lg:max-w-[7rem]"
            data={content.award?.awardImage}
          />
          <div className="flex flex-col min-w-[50%] flex-1">
            <MultiPurposeParagraph
              type="default"
              data={content.award.awardTypes?.awardCategory}
              color={color}
            />

            <MultiPurposeTitle
              tag="p"
              type="headline"
              color={color}
              data={content.wineContest?.title}
            />
          </div>
          {conf && (
            <Image
              className=" lg:flex m-auto  max-w-[4rem] lg:max-w-[6rem]"
              data={content.wineContest?.image}
            />
          )}
        </div>
        <Disclosure as="div" className="mt-2">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex gap-4 items-center ">
                {!open ? (
                  <MultiPurposeParagraph
                    type="default"
                    color={color}
                    data={t("showDetail")}
                  />
                ) : (
                  <MultiPurposeParagraph
                    type="default"
                    color={color}
                    data={t("hideDetail")}
                  />
                )}
                <span
                  className={`${
                    open ? "rotate-[-90deg] transform" : "rotate-90"
                  } `}
                >
                  <Chevron color={color} />
                </span>
              </Disclosure.Button>
              <Transition
                enter="transition duration-100 ease-out"
                enterFrom="transform opacity-0 -translate-y-2"
                enterTo="transform opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform  opacity-100"
                leaveTo="transform -translate-y-2 opacity-0"
              >
                <Disclosure.Panel className="pt-4 pb-2 flex flex-col">
                  <div className="mb-4 flex fle-row gap-12">
                    <div>
                      <MultiPurposeParagraph
                        type="default"
                        weight={"bold"}
                        data={t("country")}
                        color={color}
                      />
                      <MultiPurposeParagraph
                        data={content.country?.title}
                        color={color}
                        type="image"
                      />
                    </div>
                    <div>
                      {year && (
                        <>
                          {" "}
                          <MultiPurposeParagraph
                            data={t("year")}
                            color={color}
                            type="default"
                            weight={"bold"}
                          />
                          <MultiPurposeParagraph
                            type="image"
                            data={`${year}`}
                            color={color}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </Disclosure.Panel>
              </Transition>
            </>
          )}
        </Disclosure>
      </article>
    </>
  );
}
